var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNorthFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 170,
    viewBox: "0 0 200 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.5 80.5L74 81.5L85.5 57.5L93.5 55.5V46.5L107.5 44L108.5 52L152 39L150 42L119.5 80.5Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5 81H127V144.902L81.5 118.634V81Z",
    stroke: "#FF0000",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152 40.5L120 77.5V80.5H127V145.5L171.5 122.5V77.5H180L152 40.5Z",
    stroke: "#FF0000",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145 134.5V88.5H158V129L145 134.5Z",
    fill: "#FF0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88 91.5L97 92.5V110.5L88 109.5V91.5Z",
    fill: "#FF0000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104 93.5L117 95.5V113.5L104 111.5V93.5Z",
    fill: "#FF0000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1841 53.9999C43.1856 56.436 42.2176 58.772 40.4971 60.4956C38.775 62.2192 36.4388 63.1872 34.0029 63.1888C31.5668 63.1888 29.2308 62.2223 27.5072 60.5002C25.7836 58.7782 24.8156 56.442 24.8156 54.0061C24.8156 51.5702 25.7821 49.2324 27.5057 47.5104C29.2277 45.7883 31.5639 44.8203 33.9998 44.8203C36.4344 44.8203 38.7704 45.7868 40.4924 47.5088C42.2145 49.2294 43.1825 51.5652 43.1841 53.9999ZM33.9999 39L31.85 42.7257L36.1498 42.7273L33.9999 39ZM36.1498 65.265H31.85L33.9999 69L36.1498 65.265ZM19 53.9999L22.7257 56.1498L22.7273 51.85L19 53.9999ZM45.265 51.85V56.1498L49 53.9999L45.265 51.85ZM44.6079 43.3919L40.4511 44.5077L43.4921 47.5486L44.6079 43.3919ZM27.5487 63.5012L24.5077 60.4603L23.392 64.6075L27.5487 63.5012ZM23.3919 43.3919L24.5077 47.5487L27.5486 44.5077L23.3919 43.3919ZM43.5012 60.4511L40.4603 63.4921L44.617 64.6078L43.5012 60.4511Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthFace);
export default __webpack_public_path__ + "static/media/NorthFace.dc4d1bf3bc3f3948b53ca05540f307ec.svg";
export { ForwardRef as ReactComponent };